import {
  IconCashOutline,
  IconLayersOutline,
  IconLocationOutline,
  IconPeopleOutline,
  IconStatsChartOutline,
  IconTrendingUpOutline,
  type IconProps,
} from "@boligportal/bricks-icons";
import imgKpi from "~/assets/analyse/KPI.webp";
import imgRoi from "~/assets/analyse/ROI.webp";
import imgAttractiveAreas from "~/assets/analyse/attractive_areas.webp";
import imgDemand from "~/assets/analyse/demand.webp";
import imgMarketComposition from "~/assets/analyse/marketcomposition.webp";
import imgSupplyAndCost from "~/assets/analyse/supply_and_cost.webp";

export const SLUGS = [
  "attractive_areas",
  "ROI",
  "demand",
  "marketcomposition",
  "supply_and_cost",
  "KPI",
] as const;
export type Slug = (typeof SLUGS)[number];

type Report = {
  slug: Slug;
  icon: (props: IconProps) => React.ReactNode;
  image: string;
  imageWidth: number;
  imageHeight: number;
};

export const REPORTS: Report[] = [
  {
    slug: "attractive_areas",
    icon: IconLocationOutline,
    image: imgAttractiveAreas,
    imageWidth: 1769,
    imageHeight: 1044,
  },
  {
    slug: "ROI",
    icon: IconCashOutline,
    image: imgRoi,
    imageWidth: 1902,
    imageHeight: 1117,
  },
  {
    slug: "demand",
    icon: IconPeopleOutline,
    image: imgDemand,
    imageWidth: 1902,
    imageHeight: 1117,
  },
  {
    slug: "marketcomposition",
    icon: IconLayersOutline,
    image: imgMarketComposition,
    imageWidth: 1769,
    imageHeight: 1044,
  },
  {
    slug: "supply_and_cost",
    icon: IconTrendingUpOutline,
    image: imgSupplyAndCost,
    imageWidth: 1769,
    imageHeight: 1025,
  },
  {
    slug: "KPI",
    icon: IconStatsChartOutline,
    image: imgKpi,
    imageWidth: 1769,
    imageHeight: 1043,
  },
];
